module.exports = __webpack_public_path__ + "img/apple-pay.56355b6a.svg";